(() => {
  // Dr. Förster PDP motion layer: scroll reveals, word-by-word headlines, counters, bars, image scale.
  // Content is fully visible without JS or with reduced motion; html.drf-motion only exists when motion runs.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) document.documentElement.classList.add('drf-motion');

  const AUTO_REVEAL = [
    '.drf-pdp-section__head',
    '.drf-pdp-step',
    '.drf-pdp-ingredient',
    '.drf-pdp-accordion',
    '.drf-pdp-conversion__grid article',
    '.drf-pdp-ritual__copy',
    '.drf-pdp-ritual__product-wrap',
    '.drf-pdp-close__inner > *',
    '.drf-pdp-application__visual',
    '.drf-pdp-trust__service-card'
  ];

  const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  let revealObserver = null;
  const wordGroups = new Set();
  const scalers = new Set();

  function tagAuto(scope) {
    AUTO_REVEAL.forEach((selector) => {
      scope.querySelectorAll(selector).forEach((el, index) => {
        if (el.hasAttribute('data-drf-reveal') || el.closest('.drf-moment, .drf-statement')) return;
        el.setAttribute('data-drf-reveal', '');
        el.style.setProperty('--drf-i', String(index % 6));
      });
    });
  }

  function countUp(el) {
    const target = parseFloat(el.dataset.target || el.textContent);
    if (Number.isNaN(target)) return;
    if (reduce) { el.textContent = String(target); return; }
    const duration = 1600;
    const start = performance.now();
    const step = (now) => {
      const t = clamp((now - start) / duration);
      el.textContent = String(Math.round(target * ease(t)));
      if (t < 1) requestAnimationFrame(step);
    };
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function fillBar(el) {
    el.style.setProperty('--drf-bar', `${clamp(parseFloat(el.dataset.value || '0') / 100) * 100}%`);
  }

  function onReveal(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-drf-count')) countUp(el);
      if (el.hasAttribute('data-drf-bar')) fillBar(el);
      revealObserver.unobserve(el);
    });
  }

  function splitWords(el) {
    if (el.dataset.drfSplit === 'true') return;
    el.dataset.drfSplit = 'true';
    const lines = el.querySelectorAll('[data-drf-line]');
    const targets = lines.length ? lines : [el];
    targets.forEach((line) => {
      const words = line.textContent.trim().split(/\s+/);
      line.textContent = '';
      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.className = 'drf-word';
        span.textContent = word;
        line.appendChild(span);
        if (i < words.length - 1) line.appendChild(document.createTextNode(' '));
      });
    });
    wordGroups.add(el);
  }

  function updateScroll() {
    const vh = window.innerHeight || 800;
    wordGroups.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const progress = clamp((vh * 0.9 - rect.top) / (vh * 0.55));
      const words = el.querySelectorAll('.drf-word');
      const lit = Math.round(progress * words.length);
      words.forEach((w, i) => w.classList.toggle('is-lit', i < lit));
    });
    scalers.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const progress = clamp((vh - rect.top) / (vh * 0.8));
      el.style.setProperty('--drf-scale', String(0.9 + 0.1 * ease(progress)));
    });
    ticking = false;
  }

  let ticking = false;
  function requestTick() {
    if (!ticking) { ticking = true; requestAnimationFrame(updateScroll); }
  }

  function init(scope = document) {
    if (reduce) {
      scope.querySelectorAll('[data-drf-bar]').forEach(fillBar);
      return;
    }
    tagAuto(scope);
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(onReveal, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }
    scope.querySelectorAll('[data-drf-reveal], [data-drf-count], [data-drf-bar]').forEach((el) => revealObserver.observe(el));
    scope.querySelectorAll('[data-drf-words]').forEach(splitWords);
    scope.querySelectorAll('[data-drf-scale]').forEach((el) => scalers.add(el));
    updateScroll();
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
